// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1ZPb7","actions":"GroupTable_actions__3iWbm","deleteModalFooter":"GroupTable_deleteModalFooter__i4AWI"};